// extracted by mini-css-extract-plugin
module.exports = {"container":"NutritionLabel_container__6L1Qf","wrapper":"NutritionLabel_wrapper__YTcN4","closeModal":"NutritionLabel_closeModal__7QM_W","close":"NutritionLabel_close__t4IYJ"};